import { useEffect, useState } from "react";
import { UseFormReset, UseFormSetValue } from "react-hook-form";
import { formatCurrency } from "@trussle/external-components";
import { ILoggedInStatus } from "../../LoggedInStatus";
import { IRateWatchPanelFormValues } from ".";
import { usePreviousValues } from "./queriesAndMutations";

export const useInitialValues = (
  contactId: string,
  status: ILoggedInStatus,
  reset: UseFormReset<IRateWatchPanelFormValues>,
  _setValue: UseFormSetValue<IRateWatchPanelFormValues>,
  monthSupported?: boolean,
) => {
  const { data, loading } = usePreviousValues(contactId);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    (async () => {
      if (status === ILoggedInStatus.LOGGED_IN && !!data?.home) {
        const hasEndDate = !!data?.home.productEndDate;
        const endDate = new Date(data?.home.productEndDate);

        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const endDateString = monthSupported ? `${endDate.getFullYear()}-${month}` : `${month}/${endDate.getFullYear()}`;

        reset({
          balance: formatCurrency(data?.home.balance),
          propertyValue: formatCurrency(data?.home.propertyValue),
          repayment: formatCurrency(data?.home.currentMonthlyRepayment),
          endDate: hasEndDate ? endDateString : null,
          currentTerm: data?.home.currentTerm ?? 25,
        });

        setIsLoading(false);
      }
      if (status === ILoggedInStatus.NOT_LOGGED_IN) {
        reset({ currentTerm: 25 });
        setIsLoading(false);
      }
    })();
  }, [status, contactId, loading]);

  return { isLoading, applicationId: data?.applicationsForUser ? data.applicationsForUser[0] : undefined };
};
